export const googleMapsApiKey = "AIzaSyAUUC4keHYzwY0YcEO5QKP0DkxYr7lNl6Q";
